import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the WindowProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WindowProvider {

  constructor(public http: HttpClient) {
    console.log('Hello WindowProvider Provider');
  }
  get windowRef() {
    return window;
  }
}



// WEBPACK FOOTER //
// ./src/providers/window/window.ts